import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CtoProvider } from "../shared/CtoProvider";
import { PsContractType } from "../shared/PsContractType";
import { PsProvider } from "../shared/PsProvider";
import { PsSpecialty } from "../shared/PsSpecialty";

@Injectable()
export class Ps {
    constructor(private http: HttpClient) {

    }

    public psContractTypes: PsContractType[] = [];
    public psSpecialties: PsSpecialty[] = [];
    public psDentalSpecialties: PsSpecialty[] = [];
    public psAcupunctureSpecialties: PsSpecialty[] = [];
    //public psProviders: PsProvider[] = [];
    public psProviders: CtoProvider[] = [];

    loadPsContractTypes() {
        return this.http.get<[]>("/api/pscontracttypes")
            .pipe(map(data => {
                this.psContractTypes = data;
                return;
            }));
    }

    loadPsSpecialties() {
        return this.http.get<[]>("/api/psspecialties")
            .pipe(map(data => {
                this.psSpecialties = data;
                return;
            }));
    }

    loadPsDentalSpecialties() {
        return this.http.get<[]>("/api/psdentalspecialties")
            .pipe(map(data => {
                this.psDentalSpecialties = data;
                return;
            }));
    }

    loadPsAcupunctureSpecialties() {
        return this.http.get<[]>("/api/psacupuncturespecialties")
            .pipe(map(data => {
                this.psAcupunctureSpecialties = data;
                return;
            }));
    }

    loadPsProviders(): Observable<void> {
        return this.http.get<[]>("/api/psproviders")
            .pipe(map(data => {
                this.psProviders = data;
                return;
            }));
    }

    loadPsProvidersWithParams(name: string, location: string, contract_type: string, specialty: string): Observable<void> {
        return this.http.get<[]>("/api/psproviderswithpsparams?name=" + name + "&location=" + location + "&contract_type=" + contract_type + "&specialty=" + specialty)
            .pipe(map(data => {
                this.psProviders = data;
                return;
            }));
    }

    loadPsProviderSearch(contract_type: string, specialty: string, name: string, location: string, radius_distance: string): Observable<void> {
        return this.http.get<[]>("/api/psprovidersearch?contract_type=" + contract_type + "&specialty=" + specialty + "&name=" + name + "&location=" + location + "&radius_distance=" + radius_distance)
            .pipe(map(data => {
                this.psProviders = data;
                return;
            }));
    }

    loadPsProviderSearchWithIPA(contract_type: string, specialty: string, ipa: string, name: string, location: string, radius_distance: string, calendar_year: string): Observable<void> {
        //return this.http.get<[]>("/api/psprovidersearchwithipa?contract_type=" + contract_type + "&specialty=" + specialty + "&ipa=" + ipa + "&name=" + name + "&location=" + location + "&radius_distance=" + radius_distance)
        //    .pipe(map(data => {
        //        this.psProviders = data;
        //        return;
        //    }));

        // added calendarYear on 10/2/2023
        return this.http.get<[]>("/api/psprovidersearchwithipa?contract_type=" + contract_type + "&specialty=" + specialty + "&ipa=" + ipa + "&name=" + name + "&location=" + location + "&radius_distance=" + radius_distance + "&calendar_year=" + calendar_year)
            .pipe(map(data => {
                this.psProviders = data;
                return;
            }));
    }

    loadPsProviderSearchWithIPADirectoryType(contract_type: string, specialty: string, ipa: string, name: string, location: string, radius_distance: string, calendar_year: string, directory_type: string): Observable<void> {
        //return this.http.get<[]>("/api/psprovidersearchwithipa?contract_type=" + contract_type + "&specialty=" + specialty + "&ipa=" + ipa + "&name=" + name + "&location=" + location + "&radius_distance=" + radius_distance)
        //    .pipe(map(data => {
        //        this.psProviders = data;
        //        return;
        //    }));

        // added calendarYear on 10/2/2023
        return this.http.get<[]>("/api/psprovidersearchwithipadirectorytype?contract_type=" + contract_type + "&specialty=" + specialty + "&ipa=" + ipa + "&name=" + name + "&location=" + location + "&radius_distance=" + radius_distance + "&calendar_year=" + calendar_year + "&directory_type=" + directory_type)
            .pipe(map(data => {
                this.psProviders = data;
                return;
            }));
    }

}